import { api } from "./apiClient";

/* Kicks off a Studio generation job and polls until it finishes.
   Uses the async job pattern so long Claude Sonnet 5 generations never hit
   the ~60s Kubernetes ingress timeout. Resolves with the project dict.
   `projectId` continues an existing project instead of restarting from zero;
   `mode: "new"` forces a blank project. */
export async function generateProject(
  { prompt, kind = "auto", projectId = null, mode = "auto" },
  { pollMs = 2500, timeoutMs = 240000 } = {}
) {
  const { data } = await api.post("/studio/generate", {
    prompt,
    kind,
    project_id: projectId,
    mode,
  });
  // Backward-compat: if the server ever returns the project directly.
  if (!data.job_id) return data;

  const jobId = data.job_id;
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    await new Promise((r) => setTimeout(r, pollMs));
    const { data: st } = await api.get(`/studio/jobs/${jobId}`);
    if (st.status === "done") return st.result;
    if (st.status === "error") throw new Error(st.error || "Échec de la génération");
  }
  throw new Error("La génération a expiré. Réessayez avec une demande plus simple.");
}
